import React, { useContext, Suspense, useRef, lazy } from "react";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { makeStyles, createStyles} from "@material-ui/core";
import { IAnnounce, IPropertyType } from "../../utils/AnnounceInterfaces";
import { useTranslation, Trans } from "react-i18next";
//import { AnnounceSlide } from "./AnnounceSlide";
import classNames from 'classnames';
import { AfriqContainer } from "../components/layouts/AfriqContainer";
//import AfriqHomeCard from "../components/layouts/AfriqHomeCard";
import { Grid } from "@mui/material";
import { serverConfig } from "../../utils/config";
import { CountryService } from "../Admin/Countries/services/EquipmentCountry";
import { PropertyService } from "../Properties/services/PropertyService";
import { Parallax } from 'react-parallax';
import bg_pub from "../../images/bg_pub.svg";
import illustrated_steps_arrow_down from "../../images/illustrated_steps_arrow_down.svg";
import illustrated_steps_arrow_up from "../../images/illustrated_steps_arrow_up.svg";
import { useHistory } from 'react-router-dom';
import { useQuery } from "../../utils/App";
import { CurrencyContext } from "../../contexts/AppContext";
import { PropagateLoader } from "react-spinners";
import etape1 from "../../images/etape1_search.webp";
import etape2 from "../../images/etape2_find.webp";
import etape3 from "../../images/etape3_book.webp";
import { useUser } from "../../Hooks/UserHooks";
//import * as Annouce from '../../Services/AnnounceService';
//import Testimonials from "../components/Testimonials/Testimonials";
import { trustTestimonialData } from "../components/Testimonials/TestimonialsData";
import { testimonialDataCars } from "../components/Testimonials/TestimonialsDataCars";
import { IPays, IVille } from "../../utils/DiversInterfaces";
//import AdSenseAd from "../components/AdSenseAd";
/*
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import VerifiedIcon from '@mui/icons-material/Verified';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PaymentsIcon from '@mui/icons-material/Payments';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SpeedIcon from '@mui/icons-material/Speed';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
*/
import MasterCard_logo from "../../images/MasterCard_logo.jpg";
import MTNMobileMoney_logo from "../../images/MTNMobileMoney_logo.jpg";
import OrangeMoney_logo from "../../images/OrangeMoney_logo.jpg";
import PayPal_logo from "../../images/PayPal_logo.jpg";
import Visa2_logo from "../../images/Visa2_logo.jpg";


// Lazy loaded Material-UI icons
const TrendingFlatIcon = lazy(() => import("@material-ui/icons/TrendingFlat"));
const VerifiedIcon = lazy(() => import('@mui/icons-material/Verified'));
const OndemandVideoIcon = lazy(() => import('@mui/icons-material/OndemandVideo'));
const PaymentsIcon = lazy(() => import('@mui/icons-material/Payments'));
const SupportAgentIcon = lazy(() => import('@mui/icons-material/SupportAgent'));
const CreditScoreIcon = lazy(() => import('@mui/icons-material/CreditScore'));
const EventBusyIcon = lazy(() => import('@mui/icons-material/EventBusy'));
const LocalOfferIcon = lazy(() => import('@mui/icons-material/LocalOffer'));
const SpeedIcon = lazy(() => import('@mui/icons-material/Speed'));
const ReceiptLongIcon = lazy(() => import('@mui/icons-material/ReceiptLong'));
const DirectionsCarIcon = lazy(() => import('@mui/icons-material/DirectionsCar'));

// Dynamically import heavy components
const AfriqHomeCard = React.lazy(() => import("../components/layouts/AfriqHomeCard"));
const Testimonials = React.lazy(() => import("../components/Testimonials/Testimonials"));


const useStyles = makeStyles((theme) =>
    createStyles({
        btn: {
            color: "#890608",
            fontSize: 18,
            textAlign: "right",
            textTransform: "capitalize",
            marginTop: 20
        },
        btnContainer: {
            display: "flex",
            justifyContent: "flex-end",
        },
        slide: {
            marginTop: 66,
            marginBottom: 70,
        },
        slider: {
            height: 120,
            width: "315px !important",
            overflow: "hidden!important"
        },
        previous: {
            position: "absolute",
            top: 45,
            left: 20
        },
        next: {
            position: "absolute",
            top: 45,
            right: 20
        },
        title: {
            color: "#890608",
            fontSize: 24,
            marginBottom: 40
        },
        slideComponent: {
            marginBottom: 87,
            position: "relative"
        },
        flex: {
            display: "flex",
            position: "relative",
            marginLeft: 25,
            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
            },
        },
        bouton: {
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#7D7D57",
            color: "#ffffff",
            "&:hover": {
                background: "#B5551B"
            }
        },
        secondTitle: {
            fontWeight: "bold",
            fontSize: 18,
            color: "#000",
            marginTop: 40,
            marginBottom: 20
        },
        secondTitle2: {
            fontWeight: "bold",
            fontSize: 18,
            color: "#000",
            marginTop: 20,
        },
        link: {
            display: 'block',
            margin: '8px 0',
            textAlign: 'center',
        },
        boutonContent: {
            cursor: "pointer",
            background: "#890608",
            borderRadius: 150,
            color: "#ffffff",
            textDecoration: "none",
            textTransform: "capitalize",
            transition: "height 0.2s, visibility 0.4s, padding 0.2s, opacity 0.4s, background 0.2s linear ",
            display: "block",
            visibility: "hidden",
            padding: 0,
            opacity: 0,
            height: 0,
            "&:hover": {
                background: "rgb(234, 118, 6)",
            }
        },
        article: {
            flexDirection: "row",
            position: "relative",
            backgroundColor: "#000",
            borderRadius: 5,
            overflow: "hidden",
            height: "180px",
            "&:hover": {
                "& .hover-bouton": {
                    height: 32,
                    visibility: "visible",
                    padding: "9px 32px",
                    opacity: 1
                }
            }
        },
        image: {
            width: "100%",
            height: "100%",
            display: "block",
            objectFit: "cover",
            opacity: .7
        },
        cardContent: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            flexGrow: 1,
            position: "absolute",
            top: 0,
            alignItems: "center"
        },
        span: {
            color: "#ffffff",
            marginBottom: 23
        },
        publicitaire: {
            textAlign: 'center',
            paddingTop: '50px', // Adjust this value as needed
            paddingBottom: '50px', // Adjust this value as needed    
            margin: "15px 0",
            color: "#ffffff",
            [theme.breakpoints.down('xs')]: {
              background: `url(${bg_pub})`, // Set background image here
              backgroundSize: 'cover',
            },
        },
        welcome: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        slideLocation: {
            "& > .slick-list": {
                height: 150
            },
        },
        pub: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: '20px',
            [theme.breakpoints.down('xs')]: {
                background: `url(${bg_pub})`, // Set background image here
                backgroundSize: 'cover',
            },
        },
        span1: {
            color: 'white',
            fontSize: '18px',
            fontWeight: 'bold',
            marginTop: '20px',
            marginBottom: '0px',
        },
        span2: {
            color: 'white',
            fontSize: '14px',
            marginTop: '15px'
        },
        arrow: {
            margin: "0 10px",
            position: "relative",
            bottom: 100,
            [theme.breakpoints.down('xs')]: {
                display: 'none', // Hide the arrow on mobile
            }
        },
        loading: {
            width: "100%",
            minHeight: "40vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        titlePub: {
            fontSize: 20,
            margin: "30px 0",
            fontWeight: 700
        },
        titleA: {
            marginBottom: '15px',
        },
        cardA: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        imageA: {
            width: '371px',
            height: '352px',
            objectFit: 'cover',
        },
        cardContentA: {
            padding: '10px',
        },
        locationA: {
            fontWeight: 'bold',
        },
        detailsA: {
            color: theme.palette.text.secondary,
        },
        nameA: {
            fontWeight: 'bold',
        },
        adContainer: {
            margin: "25px auto",
            padding: "18px 15px",
            background: "#FFF9F5",
            borderRadius: 10,
            textAlign: "center",
            border: "1px solid #F0E6DF",
            boxShadow: "0 3px 6px rgba(139, 86, 27, 0.08)",
            [theme.breakpoints.down("sm")]: {
                padding: "15px 10px",
                margin: "20px auto",
            },
            },
        topAd: {
            borderTop: "4px solid #890608",
            background: "#FFF5F5",
            marginTop: 0,
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
                marginTop: 10,
            },
            },
        midAd: {
            borderLeft: "4px solid #EA7606",
            background: "#FFF8F0",
            margin: "30px auto",
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
            },
            },
        bottomAd: {
            borderBottom: "4px solid #B5551B",
            background: "#FFF6F0",
            marginTop: 40,
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
            },
        }, 
            trustSection: {
            padding: theme.spacing(3, 0),
            },
            trustGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: theme.spacing(4),
            [theme.breakpoints.down('md')]: {
                gridTemplateColumns: '1fr 1fr',
            },
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: '1fr',
            }
            },
            trustItem: {
            textAlign: 'center',
            padding: theme.spacing(3),
            },
            paymentIcons: {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.spacing(2),
            marginTop: theme.spacing(1),
            },
        "@global": {
            ".react-parallax-content": {
                height: "100%!important"
            },
        }
    })
);

/*type AnnounceSummary = {
    country: {
        _id: string;
        nomFR: string;
        nomEN: string;
    };
    announce: Array<{
        _id: string;
        nomFR: string;
        nomEN: string;
        total: number;
        photo: string | null;
    }>;
    sum: number;
};*/

/*type PropertyTypeSummary = {
    type: string;
    label: string;
    cities: Array<{
        _id: string;
        nomFR: string;
        nomEN: string;
        total: number;
        photo: string | null;
    }>;
    totalType: number;
};*/

const propertyService = new PropertyService();
const countryService = new CountryService();
const Env = serverConfig;

/* Mapping of searchType to ObjectId
const searchTypeToObjectId: { [key: string]: string } = {
    "apts": "66a4f5b161bece7e34fbe82f",
    "htls": "66a4f5b161bece7e34fbe830",
    "cars": "66a4f5b161bece7e34fbe831",
    "evts": "66a4f5b161bece7e34fbe832",
    "rstt": "66a4f5b161bece7e34fbe833",
    "trs": "66a4f5b161bece7e34fbe834",
}; */

interface AnnounceSliderProps {
    list: any[];
    searchTypeName: "cars" | "apts" | "htls" | "trs" | "evts" | "rstt";
}

export function AnnounceSlider(props: AnnounceSliderProps) {
    const { searchTypeName, list } = props; 
    const classes = useStyles();
    const { t, i18n } = useTranslation<'common'>();
    const [listCountry, setListCountry] = React.useState<IPays[]>([]);
    const [locationType, setLocationTypeList] = React.useState<IPropertyType[]>([]);
    const { user, setUser } = useUser();
    const [announces, setAnnounces] = React.useState<IAnnounce[]>(list || []);
    const [loading, setLoading] = React.useState<boolean>(!list);
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;
    const history = useHistory();
    let query = useQuery();
    const observerRef = useRef(null); 
    const [isVisible, setIsVisible] = React.useState(false);

    //const searchTypeId = searchTypeToObjectId[searchType]; // Convert searchType to ObjectId

    React.useEffect(() => {
        if (list && list.length > 0) {
            setAnnounces(list);
            setLoading(false);
        } else {
            setLoading(false); // Ensure loading stops even if list is empty
        }
    }, [list])


    React.useEffect(() => {
        const currentRef = observerRef.current; // Capture current value
        const observer = new IntersectionObserver(
            ([entry]) => setIsVisible(entry.isIntersecting),
            { threshold: 0.1 }
        );
        
        if (currentRef) observer.observe(currentRef);

        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, []); // Empty dependency array is correct here


    React.useEffect(() => {
        propertyService
            .getPropertyTypesBySearchType(searchTypeName) // Use ObjectId for fetching
            .then((response) => {
                if (response.success) {
                    //console.log('Property types fetched for searchTypeName', searchTypeName, ':', response.data);
                    setLocationTypeList(response.data);
                } else {
                    //console.log('Failed to fetch property types for searchTypeName', searchTypeName);
                }
            })
            .catch((err: any) => {
                //console.log('Error fetching property types:', err);
            });

        
    }, [searchTypeName]); 


    React.useEffect(() => {
        countryService.getAllCountries().then(response => {
            if (response.success) {
                //console.log('getAllCountries fetched:', response.data);
                setListCountry(response.data)
            } else {
                //console.log('Failed to fetch countries and destinations');
            }
        })
    }, [setListCountry]);

    // Initialize the main array to store countries and their announcements
    let tab: Array<{ country: string; announce: Array<{ city: string; announce: IAnnounce[]; total: number }>; sum: number }> = [];

    //console.log("listCountry:", listCountry);
    //console.log("announces:", announces);
    //console.log("locationType:", locationType);

    try {
        listCountry?.forEach((country: IPays) => {
            let cityAnnouncements: Array<{ city: string; announce: IAnnounce[]; total: number }> = [];
            let countryTotal = 0;
    
            // Check if country and its 'villes' are valid
            //console.log(`Processing country: ${country.name}`);
            country.villes?.forEach((city: IVille) => {
                // Ensure that city has the expected properties before proceeding
                if (typeof city === "object" && "name" in city) {
                    const filteredAnnouncements = (announces ?? []).filter((announce: IAnnounce) =>
                        announce.property &&
                        announce.property.address.city?._id === city._id &&
                        locationType.some((type: IPropertyType) => announce.property?.type?._id === type._id)
                    );
    
                    //console.log(`Filtered announcements for city ${city.name}:`, filteredAnnouncements);
    
                    const cityTotal = filteredAnnouncements.length;
                    cityAnnouncements.push({ city: city.name, announce: filteredAnnouncements, total: cityTotal });
                    
                    countryTotal += cityTotal;
                } else {
                    console.warn("City does not have a 'name' property or is not an object:", city);
                }
            });
    
            // Sort cities in descending order of total announcements
            cityAnnouncements.sort((a, b) => b.total - a.total);
            //console.log(`City announcements for country ${country.name}:`, cityAnnouncements);
    
            // Add sorted city announcements to the main array
            tab.push({ country: country.name, announce: cityAnnouncements, sum: countryTotal });
            //console.log(`Total announcements for country ${country.name}: ${countryTotal}`);
        });
    
        // Final output
        //console.log("Final 'tab':", tab);
    
    } catch (error) {
        console.error("An error occurred during processing:", error);
    }

    let tab_type: Array<{
        type: string;
        announce: IAnnounce[];
        total: number;
        label: string;
    }> = [];

    // Filtering announcements by property type and pushing results to `tab_type`
    locationType?.forEach((propertyType: IPropertyType) => {
        const announce = (announces ?? []).filter(
            (anonce) => anonce.property && anonce.property.type._id === propertyType._id
        );
        
        tab_type.push({
            type: propertyType.name ?? '',
            announce,
            total: announce.length,
            label: propertyType.label ? t(propertyType.label) : propertyType.name,
        });

    });

    // Sorting `tab_type` based on the total count
    tab_type.sort((a, b) => b.total - a.total);

    let tabType: Array<{
        type: string;
        annonce: Array<{ ville: string; annonce: IAnnounce[]; total: number }>;
        totalType: number;
        label: string;
    }> = [];



    // Grouping announcements by city within each property type
    tab_type.forEach((annonce: any) => {
        let tabVilleAnonce: Array<{ ville: string; annonce: IAnnounce[]; total: number }> = [];
    
        if (annonce.announce !== undefined) {
            (listCountry as IPays[]).forEach((country: IPays) => {
                (country.villes as IVille[] | undefined)?.forEach((ville: IVille) => {
                    const filteredAnnouncements = annonce.announce.filter((val: any) => {
                        const cityName = val.property?.address?.city?.name || ''; 
                        const isMatch = ville.name === cityName;
                        return isMatch;
                    });
    
                    const total = filteredAnnouncements.length;
    
                    tabVilleAnonce.push({
                        ville: ville.name,
                        annonce: filteredAnnouncements,
                        total: total,
                    });
                });
            });
    
            tabVilleAnonce.sort((a, b) => b.total - a.total);
        }
    
        tabType.push({
            type: annonce.type,
            annonce: tabVilleAnonce,
            totalType: annonce.total,
            label: annonce.label,
        });

        
    });
    

    const clickVille = (countryName: string) => {
        //console.log("clickVille called with countryName:", countryName);

        const selectedCountry = listCountry.find(
            (country: IPays) => country.name?.toLowerCase() === countryName.toLowerCase()
        ) as IPays | undefined;

        if (!selectedCountry) {
            console.error(`Country "${countryName}" not found`);
            //console.log("Available country names:", listCountry.map(c => c.name));
            return;
        }

        const countryId = selectedCountry._id;
        //console.log("Found country:", selectedCountry.name, "ID:", countryId);

        if (countryId) {
            query.set('search_pays', countryId);
            query.set('search_adresse', '');
            query.set('quartier','');
            query.set('currencyBase', selectedCountry.currencyCode || '');
            query.set('currency', currency.toString());
            query.set('refreshData', '2');

            query.set('offer', '0');
            query.set('travellerChildTotal', '0');
            query.set('travellerAdultTotal', '2');

            query.set('eqt', [""].toString());
            query.set('page', "1");
            query.set('rooms', [""].toString());
            query.set('click', [""].toString());
            query.set('luxury', "false");
            query.set('perle', "false");
            query.set('business', "false");
            query.set("type", props.searchTypeName);

            //console.log("Redirecting with query:", query.toString());
            history.push({ pathname: "/search", search: query.toString() });
        } else {
            console.warn("Country with the provided name not found or does not have an ID");
        }
    };


    const clickTypeLogement = (ville: string, type: string) => {
        //console.log(`🟡 ClickTypeLogement triggered with ville: "${ville}", type: "${type}"`);

        if (!ville || ville === "undefined") {
            console.error('❌ City name is undefined or empty');
            return;
        }

        // Step 1: Find the matching country for the given city
        const selectedCountry = listCountry.find((country: IPays) =>
            country.villes?.some((vil: IVille) =>
                vil.name?.toLowerCase() === ville?.toLowerCase()
            )
        );

        if (!selectedCountry) {
            console.warn(`❌ Country not found for city: "${ville}"`);
            /*console.log("ℹ️ Available cities by country:", listCountry.flatMap(c =>
                c.villes?.map(v => ({ city: v.name, country: c.name }))
            )); */
            return;
        }

        //console.log(`✅ Country "${selectedCountry.name}" found for city "${ville}"`);

        // Step 2: Find the selected city object
        const selectedCity = selectedCountry.villes?.find(
            (vil: IVille) => vil.name?.toLowerCase() === ville?.toLowerCase()
        );

        if (!selectedCity) {
            console.warn(`❌ City "${ville}" not found in country "${selectedCountry.name}"`);
            return;
        }

        //console.log(`✅ City "${selectedCity.name}" found with ID: ${selectedCity._id}`);

        const countryId = selectedCountry._id;
        const cityId = selectedCity._id;

        if (!countryId || !cityId) {
            console.warn("❌ Country ID or City ID is undefined");
            return;
        }

        const currencyBase = selectedCountry.currencyCode || '';
        //console.log(`💰 Currency base for ${selectedCountry.name}: ${currencyBase}`);

        // Step 3: Set query params
        query.set('search_adresse', cityId);
        query.set('search_pays', countryId);
        query.set('quartier','');
        query.set('currency', currency.toString());
        query.set('currencyBase', currencyBase);
        query.set('refreshData', '1');
        query.set('offer', '0');
        query.set('eqt', [""].toString());
        query.set('page', "1");
        query.set('click', type.toString());
        query.set('rooms', [""].toString());
        query.set('luxury', "false");
        query.set('perle', "false");
        query.set('business', "false");
        query.set('type', props.searchTypeName);

        //const constructedUrl = `/search?${query.toString()}`;
        //console.log("🔗 Constructed search link:", constructedUrl);

        // Step 4: Redirect
        history.push({ pathname: "/search", search: query.toString() });
    };


    const clickdestination = (country: string, city: string) => {
        //console.log("clickdestination called with country:", country, "and city:", city);

        const selectedCountry = listCountry.find((item: IPays) =>
            item.name?.toLowerCase() === country.toLowerCase()
        ) as IPays | undefined;

        if (!selectedCountry) {
            console.warn("Country not found");
            //console.log("Available countries:", listCountry.map(c => c.name));
            return;
        }

        const selectedCity = selectedCountry.villes?.find((vil) => {
            const vilName = (vil as IVille)?.name;
            return vilName && city && vilName.toLowerCase() === city.toLowerCase();
        }) as IVille | undefined;

        //console.log("selectedCountry.villes", selectedCountry.villes);
        //console.log("city", city);


        if (!selectedCity) {
            console.warn("City not found in the specified country");
            //console.log("Cities in selected country:", selectedCountry.villes?.map(v => (v as IVille).name));
            return;
        }

        const countryId = selectedCountry._id;
        const cityId = selectedCity._id;
        //console.log("Selected destination IDs:", { countryId, cityId });

        if (!countryId || !cityId) {
            console.warn("Country ID or City ID is undefined");
            return;
        }

        const currencyBase = selectedCountry.currencyCode || '';

        query.set('search_pays', countryId);
        query.set('search_adresse', cityId);
        query.set('quartier','');
        query.set('currencyBase', currencyBase);
        query.set('refreshData', '2');
        query.set('currency', currency.toString());

        query.set('offer', '0');
        query.set('travellerChildTotal', '0');
        query.set('travellerAdultTotal', '2');

        query.set('eqt', [""].toString());
        query.set('page', "1");
        query.set('rooms', [""].toString());
        query.set('click', [""].toString());
        query.set('luxury', "false");
        query.set('perle', "false");
        query.set('business', "false");
        query.set('type', props.searchTypeName);

        //console.log("Redirecting with query:", query.toString());
        history.push({ pathname: "/search", search: query.toString() });
    };



    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    if (loading) {
        return <div className={classes.loading}>
        <PropagateLoader color="#36D7B7" size={15} />
    </div>;
    }

    if (!announces || announces.length === 0) {
        return null;
    }


    
    const paymentLogos = [MTNMobileMoney_logo, OrangeMoney_logo, PayPal_logo, Visa2_logo, MasterCard_logo];

    /*Before passing to AfriqHomeCard
        console.log('Filtered ambassador announces:', 
            shuffleArray(announces.filter(announce => {
            console.log('Ambassador status for', announce._id, ':', announce.ambassador);
            return announce.ambassador;
            })).slice(0, 12)
        );

        // 1. Debug the tab generation (for destinations section)
        console.log('Generated tab data:', {
            tab,
            listCountry: listCountry?.map(c => ({name: c.name, villes: c.villes?.length})),
            announcesCount: announces?.length,
            locationTypes: locationType?.map(t => t.name)
        });
        
        // 2. Debug the tabType generation (for types d'hébergement section)
        console.log('Generated tabType data:', {
            tabType,
            tab_type: tab_type?.map(t => ({
            type: t.type, 
            total: t.total,
            announce: t.announce?.length
            }))
        }); */

    return (
        <div className={classes.slide}>
            {searchTypeName === "apts" && (
            <AfriqContainer>                
                <div className={classes.trustSection}>
                    <h2 className={classes.title} style={{ marginBottom: "15px"}}>{t("home.whyChoose")}</h2>
                    <div className={classes.trustGrid}>
                        <div className={classes.trustItem}>
                            <VerifiedIcon style={{ fontSize: "40px" }}  />
                            <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.verifiedProperties")}</h3>
                            <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.verifiedPropertiesDesc")}</p>
                        </div>
                        <div className={classes.trustItem}>
                            <OndemandVideoIcon style={{ fontSize: "40px" }}  />
                            <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.videoListings")}</h3>
                            <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.videoListingsDesc")}</p>
                        </div>
                        <div className={classes.trustItem}>
                            <PaymentsIcon style={{ fontSize: "40px" }}  />
                            <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.localPayments")}</h3>
                            <div className={classes.paymentIcons}>                        
                                    <Grid container justifyContent="center" alignItems="center" style={{ width: '100%' }}>
                                        {paymentLogos.map((logo, index) => (
                                        <Grid item key={index}>
                                            <img
                                            src={logo}
                                            alt={`payment-method-${index}`}
                                            style={{
                                                padding: "4px",
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "contain",
                                                borderRadius: "4px",
                                            }}
                                            />
                                        </Grid>
                                        ))}
                                    </Grid>
                            </div>
                        </div>
                        <div className={classes.trustItem}>
                            <SupportAgentIcon style={{ fontSize: "40px" }}  />
                            <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.24Support")}</h3>
                            <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.24SupportDesc")}</p>
                        </div>
                    </div>
                </div>   
            </AfriqContainer>
            )}

            {searchTypeName === "htls" && (
            <AfriqContainer>                
                <div className={classes.trustSection}>
                <h2 className={classes.title} style={{ marginBottom: "15px", marginTop: "60px" }}>{t("home.whyChooseHotels")}</h2>
                <div className={classes.trustGrid}>
                    <div className={classes.trustItem}>
                    <VerifiedIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.verifiedProperties")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.verifiedPropertiesDesc")}</p>
                    </div>
                    <div className={classes.trustItem}>
                    <CreditScoreIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.bnplFeature")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.bnplFeatureDesc")}</p>
                    </div>
                    <div className={classes.trustItem}>
                    <EventBusyIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.freeCancellation")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.freeCancellationDesc")}</p>
                    </div>
                    <div className={classes.trustItem}>
                    <LocalOfferIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.bestPrice")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.bestPriceDesc")}</p>
                    </div>
                </div>
                </div>   
            </AfriqContainer>
            )}


            {searchTypeName === "cars" && (
            <AfriqContainer>                
                <div className={classes.trustSection}>
                <h2 className={classes.title} style={{ marginBottom: "15px", marginTop: "60px" }}>{t("home.whyChooseCars")}</h2>
                <div className={classes.trustGrid}>
                    <div className={classes.trustItem}>
                    <VerifiedIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.verifiedProperties")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.verifiedPropertiesDesc")}</p>
                    </div>
                    <div className={classes.trustItem}>
                    <SpeedIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.unlimitedMileage")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.unlimitedMileageDesc")}</p>
                    </div>
                    <div className={classes.trustItem}>
                    <ReceiptLongIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.noHiddenFees")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.noHiddenFeesDesc")}</p>
                    </div>
                    <div className={classes.trustItem}>
                    <DirectionsCarIcon style={{ fontSize: "40px" }} />
                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px", color: "#890608" }}>{t("home.wideSelection")}</h3>
                    <p style={{ marginBottom: "5px", marginTop: "5px", fontSize: "16px" }}>{t("home.wideSelectionDesc")}</p>
                    </div>
                </div>
                </div>   
            </AfriqContainer>
            )}
            
            <Suspense fallback={<PropagateLoader color="#36D7B7" size={15} />}>
                <AfriqHomeCard
                    announces={shuffleArray(announces.filter((announce) => announce.ambassador)).slice(0, 12)}
                    user={user}
                    changingFav={false}
                    onAddToFavorite={() => {}}
                    onRemoveToFavorite={() => {}}
                    searchTypeName={props.searchTypeName}
                    usage="announceSlider"
                />
            </Suspense>

            {/* AdSense HOMEPAGE_ANNOUNCESLIDER_TOP_SLOT  
            <div style={{marginTop:30}}>
             <AdSenseAd slotId="9449891280" className={`${classes.adContainer} ${classes.topAd}`} />    
            </div> */}

            <AfriqContainer>
                <h2 className={classes.title} style={{ marginBottom: "15px", marginTop: "60px" }}>
                    {t(`announceSlider.${props.searchTypeName}.nos-destinations`)}
                </h2>
                <p style={{ fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.paysIntro`)}</p>
                {announces === undefined ? (
                    <div className={classes.loading}>
                        <PropagateLoader color="#36D7B7" size={15} />
                    </div>
                ) : (
                    <div>
                        {tab?.map((list: any, tabIndex: number) => {
                            //console.log(`Rendering country ${list.country} with ${list.sum} announces`);

                            if (list.sum > 0) {
                                return (
                                    <div key={list.country}>
                                        <div className={classes.secondTitle}>
                                            {listCountry.map((pays: IPays, paysIndex: number) => {
                                                //console.log(`Checking listCountry at index ${paysIndex}:`, pays);  // Debug: Each country in `listCountry`
                                                if (pays.name === list.country) {
                                                    return (
                                                        <h3 key={pays.name}>
                                                            {i18n.language === 'fr' ? pays.nomFR : pays.nomEN}
                                                        </h3>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </div>
                                        <Grid container spacing={3}>
                                            {list.announce?.map((anonce: any, idx: number) => {
                                                if (anonce.total >= 1) {
                                                    
                                                    return (
                                                        <Grid item lg={3} md={4} sm={6} xs={12} key={`${anonce.city}-${idx}`}>
                                                            <article className={classes.article}>
                                                                <img
                                                                    src={`${Env.ApiRoot}/images/properties/${anonce.announce[Math.floor(Math.random() * (anonce.total - 1))].property.photos[0] && anonce.announce[Math.floor(Math.random() * (anonce.total - 1))].property.photos[0]?.filename}`}
                                                                    className={classes.image}
                                                                    alt={`Choix de logements à ${anonce.city}`}
                                                                    loading="lazy"
                                                                />
                                                                <div className={classes.cardContent}>
                                                                    <h4 className={classes.span}>
                                                                        {anonce.city} ({anonce.total})
                                                                    </h4>
                                                                    <a
                                                                        href="/search"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            clickdestination(list.country, anonce.city);
                                                                        }}
                                                                        className={classNames(classes.boutonContent, 'hover-bouton')}
                                                                    >
                                                                        {t('see-anouncement')}
                                                                    </a>
                                                                </div>
                                                            </article>
                                                        </Grid>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </Grid>
                                        <div className={classes.btnContainer}>
                                            <a
                                                href="/search"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    clickVille(list.country);
                                                }}
                                                className={classNames(classes.btn, 'hover-btn')}
                                            >
                                                {t('home.more')}
                                                <TrendingFlatIcon style={{ fontSize: 20, marginLeft: 5 }} />
                                            </a>
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>  
                )}
            </AfriqContainer>

            <AfriqContainer>
                <div>
                    <h2 className={classes.title} style={{ marginBottom: "15px" }}>{t(`announceSlider.${props.searchTypeName}.tailoredStays.title`)}</h2>
                    <p style={{ fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.tailoredStays.text`)}</p>

                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.curatedForYou.title`)}</h3>
                    <p style={{ marginTop: "5px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.curatedForYou.text`)}</p>

                    <ul>
                        <li style={{ marginBottom: "5px", fontSize: "16px" }}><strong style={{ color: '#890608' }}>{t(`announceSlider.${props.searchTypeName}.curatedForYou.premiumTitle`)}:</strong> {t(`announceSlider.${props.searchTypeName}.curatedForYou.premiumText`)}</li>
                        <li style={{ marginBottom: "5px", fontSize: "16px" }}><strong style={{ color: '#890608' }}>{t(`announceSlider.${props.searchTypeName}.curatedForYou.prestigeTitle`)}:</strong> {t(`announceSlider.${props.searchTypeName}.curatedForYou.prestigeText`)}</li>
                        <li style={{ fontSize: "16px" }}><strong style={{ color: '#890608' }}>{t(`announceSlider.${props.searchTypeName}.curatedForYou.standardTitle`)}:</strong> {t(`announceSlider.${props.searchTypeName}.curatedForYou.standardText`)}</li>
                    </ul>

                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.peaceOfMind.title`)}</h3>
                    <p style={{ marginTop: "5px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.peaceOfMind.text`)}</p>

                    <h3 style={{ marginBottom: "5px", marginTop: "20px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.localExperience.title`)}</h3>
                    <p style={{ marginTop: "5px", fontSize: "16px" }}>
                        <Trans i18nKey={`announceSlider.${props.searchTypeName}.localExperience.text`}>
                            Grâce à nos magazines <a href="https://afriqpnb.com/guide-touristique" target="_blank" rel="noopener noreferrer">Proud & Beautiful</a>, nous vous fournissons des conseils de voyage locaux, des expériences authentiques et des recommandations de confiance.
                        </Trans>
                    </p>
                </div>
            </AfriqContainer>

            <AfriqContainer>
                <h2 className={classes.title} style={{ marginTop: "50px", marginBottom: "15px" }}>{t(`announceSlider.${props.searchTypeName}.comment-reserver-sur-afriqpnb`)}</h2>
            </AfriqContainer>

            <Parallax bgImage={bg_pub} strength={500} className={classes.publicitaire}>
                <div className={classes.welcome}>
                    <div className={classes.pub}>
                        <img src={etape1} alt={t(`announceSlider.${props.searchTypeName}.label.rechercher`)} width="300px" style={{ borderRadius: "20px" }} />
                        <h3 className={classes.span1}>{t(`announceSlider.${props.searchTypeName}.label.rechercher`)}</h3>
                        <span className={classes.span2}>{t(`announceSlider.${props.searchTypeName}.label.choisissez-votre-destination`)}</span>
                    </div>
                    <img src={illustrated_steps_arrow_up} alt="" className={classes.arrow} style={{ marginTop: "110px" }} width="90px" />
                    <div className={classes.pub}>
                        <img src={etape2} alt={t(`announceSlider.${props.searchTypeName}.label.trouver`)} width="300px" style={{ borderRadius: "20px" }} />
                        <h3 className={classes.span1}>{t(`announceSlider.${props.searchTypeName}.label.trouver`)}</h3>
                        <span className={classes.span2}>{t(`announceSlider.${props.searchTypeName}.label.comparer`)}</span>
                    </div>
                    <img src={illustrated_steps_arrow_down} alt="" className={classes.arrow} style={{ marginTop: "110px" }} width="90px" />
                    <div className={classes.pub}>
                        <img src={etape3} alt={t(`announceSlider.${props.searchTypeName}.label.reserver`)} width="300px" style={{ borderRadius: "20px" }} />
                        <h3 className={classes.span1}>{t(`announceSlider.${props.searchTypeName}.label.reserver`)}</h3>
                        <span className={classes.span2}>{t(`announceSlider.${props.searchTypeName}.label.faites-votre-reservation`)}</span>
                    </div>
                </div>
            </Parallax>

            <AfriqContainer>
                <h3 style={{ marginBottom: "10px", marginTop: "20px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.step1Title`)}</h3>
                <p style={{ marginBottom: "15px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.step1Description`)}</p>
                <h3 style={{ marginBottom: "10px", marginTop: "20px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.step2Title`)}</h3>
                <p style={{ marginBottom: "15px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.step2Description`)}</p>
                <h3 style={{ marginBottom: "10px", marginTop: "20px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.step3Title`)}</h3>
                <p style={{ marginBottom: "15px", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.step3Description`)}</p>
                <p style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>{t(`announceSlider.${props.searchTypeName}.bookingSteps.conclusion`)}</p>
            </AfriqContainer>

            {/* AdSense HOMEPAGE_ANNOUNCESLIDER_MID_SLOT  
            <AdSenseAd slotId="9294812767" className={`${classes.adContainer} ${classes.midAd}`} />    */}
            

            <AfriqContainer>
                <h2 className={classes.title} style={{ marginTop: "50px", marginBottom: "15px" }}>
                    {t(`announceSlider.${props.searchTypeName}.nos-types-d-hebergement`)}
                </h2>
                <p>{t(`announceSlider.${props.searchTypeName}.villesIntro`)}</p>
                {announces === undefined ? (
                    <div className={classes.loading}>
                        <PropagateLoader color="#36D7B7" size={15} />
                    </div>
                ) : (        
                    <div style={{ marginBottom: 100 }}>
                        {tabType?.map((list: any, tabTypeIndex: number) => {
                            //console.log(`Rendering property type ${list.type} (${list.label}) with ${list.totalType} announces`);

                            if (list.totalType > 0) {
                                return (
                                    <div key={list.type}>
                                        <h3 className={classes.secondTitle}>{list.label}</h3>
                                        <Grid container spacing={3}>
                                            {list.annonce?.map((anonce: any, idx: number) => {
                                            const cityName = anonce.ville || anonce.city;
                                            if (!cityName) {
                                                console.warn('Missing city name for announce:', anonce);
                                                return null;
                                            }

                                            if (anonce.annonce.length > 0) {
                                                return (
                                                    <Grid item lg={3} md={4} sm={6} xs={12} key={`${cityName}-${idx}`}>
                                                        <article className={classes.article}>
                                                            <img
                                                                src={`${Env.ApiRoot}/images/properties/${anonce.annonce[0]?.property?.photos[0]?.filename}`}
                                                                className={classes.image}
                                                                alt={`Choix de Logements à ${list.label} ${cityName}`}
                                                            />
                                                            <div className={classes.cardContent}>
                                                                <h4 className={classes.span}>
                                                                    {cityName} ({anonce.total})
                                                                </h4>
                                                                <a
                                                                    href="/search"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        clickTypeLogement(cityName, list.type);
                                                                    }}
                                                                    className={classNames(classes.boutonContent, 'hover-bouton')}
                                                                >
                                                                    {t('announceSlider.apts.see-anouncement')}
                                                                </a>
                                                            </div>
                                                        </article>
                                                    </Grid>
                                                );
                                            }
                                            return null;
                                        })}
                                        </Grid>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                )}
            </AfriqContainer>
            
            {/* AdSense HOMEPAGE_ANNOUNCESLIDER_BOTTOM_SLOT  */}
            {/* <AdSenseAd slotId="8762763051" className={`${classes.adContainer} ${classes.bottomAd}`} />  */}


            {["apts", "htls", "cars"].includes(searchTypeName) && (
            <AfriqContainer>
                <h2 className={classes.title} style={{ marginTop: "50px", marginBottom: "15px" }}>{t(`announceSlider.${props.searchTypeName}.temoignages`)}</h2>
                <Suspense fallback={<PropagateLoader color="#36D7B7" size={15} />}>
                    <div>
                        <Testimonials 
                            testimonials={searchTypeName === "cars" ? testimonialDataCars : trustTestimonialData} 
                            initialNumToShow={10} 
                            numToShow={25} 
                        />
                    </div>
                </Suspense>
            </AfriqContainer>
            )}


        </div>
    );
}